import TimeCount from "./TimeCount";

export default TimeCount;